import { render, staticRenderFns } from "./addOrder.vue?vue&type=template&id=1fd00f47&scoped=true"
import script from "./addOrder.vue?vue&type=script&lang=js"
export * from "./addOrder.vue?vue&type=script&lang=js"
import style0 from "./addOrder.vue?vue&type=style&index=0&id=1fd00f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd00f47",
  null
  
)

export default component.exports